import { Sparkles, TrendingUp } from "lucide-react";

import { formatCurrency } from "@/lib/utils";

interface Props {
  totalRecipeCost: number;
  yieldQty: number;
  computedCogs: number;
  marginPercent: string;
  /** products.cogs: average of real production batches, not today's recipe cost. */
  storedCogs?: number;
}

/** Real-time batch cost, new COGS per portion and gross margin estimate. */
export function ProductRecipeSummaryCard({
  totalRecipeCost,
  yieldQty,
  computedCogs,
  marginPercent,
  storedCogs,
}: Props) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 rounded-lg border bg-primary/5 border-primary/20 p-3.5">
      <div>
        <span className="text-[11px] text-muted-foreground block">
          Total Biaya Resep (Batch)
        </span>
        <span className="text-base font-bold text-foreground">
          {formatCurrency(totalRecipeCost)}
        </span>
        <span className="text-[10px] text-muted-foreground block">
          Untuk {yieldQty} porsi / cup
        </span>
      </div>

      <div className="border-t sm:border-t-0 sm:border-l sm:pl-3 pt-2 sm:pt-0">
        <span className="text-[11px] text-muted-foreground block flex items-center gap-1">
          <Sparkles className="h-3 w-3 text-primary" />
          Estimasi HPP Resep per Porsi
        </span>
        <span className="text-xl font-extrabold text-primary">
          {formatCurrency(computedCogs)}
        </span>
        <span className="text-[10px] text-muted-foreground block">
          Harga bahan sekarang ÷ Yield ({yieldQty})
        </span>
        {storedCogs !== undefined && (
          <span className="text-[10px] text-muted-foreground block">
            HPP produk (rata-rata produksi): {formatCurrency(storedCogs)}
          </span>
        )}
      </div>

      <div className="border-t sm:border-t-0 sm:border-l sm:pl-3 pt-2 sm:pt-0">
        <span className="text-[11px] text-muted-foreground block flex items-center gap-1">
          <TrendingUp className="h-3 w-3 text-emerald-500" />
          Estimasi Gross Margin
        </span>
        <span
          className={`text-base font-bold ${
            parseFloat(marginPercent) >= 50
              ? "text-emerald-600 dark:text-emerald-400"
              : parseFloat(marginPercent) > 0
                ? "text-amber-600 dark:text-amber-400"
                : "text-destructive"
          }`}
        >
          {marginPercent}%
        </span>
        <span className="text-[10px] text-muted-foreground block">
          Margin = (Harga - HPP) ÷ Harga
        </span>
      </div>
    </div>
  );
}
